import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import {
  LoginRequest,
  LoginResponse,
} from '@/repositories/generated';
import { ErrorBody } from '@/types';

export const login = http.post(
  createMockEndpoint('/login'),
  async ({ request }) => {
    const requestBody = await request.json() as LoginRequest;
    await delay(500);

    const createResponse = (): ErrorBody | LoginResponse => {
      switch (requestBody.loginId) {
        case 'LOGIN_ID_MOCK_API_ERROR':
          return {
            error: {
              code: 'MOCK_API_ERROR',
              message: 'モック用エラー。ログインに失敗しました。ログインIDとパスワードをご確認の上、再度ログインしてください。',
            },
          };
        case 'LOGIN_ID_AUTH_MAIL':
          return {
            status: 'AUTH_MAIL',
          };
        case 'LOGIN_ID_CHANGE_PASSWORD':
          return {
            status: 'CHANGE_PASSWORD',
          };
        case 'LOGIN_ID_SUCCESS':
        default:
          return {
            status: 'SUCCESS',
          };
      }
    };

    const response = createResponse();
    const statusCode = 'error' in response ? 401 : 200;

    return HttpResponse.json(response, { status: statusCode });
  },
);
